import { BaseEventTracking } from '/@/modules/core/app/models/abstracts/BaseEventTracking';
import { SegmentEvent } from '/@/integrations/segment/SegmentEvent';

export class ReferralShareClickedEventTracking extends BaseEventTracking {
  static eventName: string = SegmentEvent.FREEWILL_REFERRAL_SHARE_CLICKED;

  device: string;

  medium: string;

  constructor(device: string, medium: string) {
    super();

    this.device = device;
    this.medium = medium;
  }
}
